export default __webpack_public_path__ + "static/media/nl-fr.055195f4.svg";